/**
 * Checks if a string contains only uppercase letters.
 *
 * @param {string} label - The string to check for uppercase letters
 * @returns {boolean} True if the string contains only uppercase letters, false for empty strings
 */
export function isLabelUppercase(label) {
    if (label.length === 0)
        return false;
    return /^[A-Z]*$/.test(label);
}
